import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { logApiError, logUnexpectedError } from '../Utils/apiError';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('ready'); // ready | success | error
  const [error, setError] = useState('');

  const validatePasswordRules = (password) => {
    const lengthOk = password.length >= 8;
    const hasUpper = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    return {
      lengthOk,
      hasUpper,
      hasNumber,
      allValid: lengthOk && hasUpper && hasNumber,
    };
  };

  const rules = validatePasswordRules(newPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setStatus('error');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (!rules.allValid) {
      setError('Password does not meet requirements.');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/public/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
      });

      if (!response.ok) {
        await logApiError(response, 'Password reset failed');
        throw new Error('Reset failed');
      }
      setStatus('success');
    } catch (err) {
      logUnexpectedError(err, 'Password reset request failed');
      setStatus('error');
    }
  };

  return (
    <div style={{
      maxWidth: '400px',
      margin: '3rem auto',
      padding: '2rem',
      border: '1px solid #ccc',
      borderRadius: '8px'
    }}>
      <h2>Reset Password</h2>
      {status === 'success' ? (
        <>
          <p>✅ Your password has been reset successfully.</p>
          <Link to="/login">Back to Login</Link>
        </>
      ) : status === 'error' ? (
        <p style={{ color: 'red' }}>❌ Invalid or expired reset token.</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
          />

          <div style={{ fontSize: '0.9rem', color: '#555', marginTop: '-0.5rem', marginBottom: '1rem', textAlign: 'left' }}>
            <p style={{ marginBottom: '0.3rem' }}>Password must include:</p>
            <ul style={{ paddingLeft: '1.2rem' }}>
              <li style={{ color: rules.lengthOk ? '#00796B' : '#c00' }}>
                {rules.lengthOk ? '✅' : '❌'} At least 8 characters
              </li>
              <li style={{ color: rules.hasUpper ? '#00796B' : '#c00' }}>
                {rules.hasUpper ? '✅' : '❌'} An uppercase letter
              </li>
              <li style={{ color: rules.hasNumber ? '#00796B' : '#c00' }}>
                {rules.hasNumber ? '✅' : '❌'} A number
              </li>
            </ul>
          </div>

          {error && <p style={{ color: 'red' }}>{error}</p>}

          <button type="submit" style={{
            width: '100%',
            padding: '0.75rem',
            backgroundColor: '#00796B',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            fontWeight: 'bold'
          }}>
            Reset Password
          </button>
        </form>
      )}
    </div>
  );
}

export default ResetPasswordPage;
